import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { authService } from "../services";

//********* Create Context *********************************
const AuthContext = createContext();

//********  Provide Auth Context ***********************************
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken") || null);
  const [loading, setLoading] = useState(false);

  const [loginPassword, setLoginPassword] = useState(null);

//*********************Login Function **************************
  const login = async (credentials) => {
    setLoading(true);
    try {
      const response = await authService.loginService(credentials);
      if (response.success) {
        const { token, refToken, userId, firstName, email } = response.data;

        //*********  Save Token & User Data ************************
        localStorage.setItem("authToken", token);
        localStorage.setItem("refreshToken", refToken);
        setAuthToken(token);
        setUser({ userId, firstName, email });


        setLoginPassword(credentials.password);
        //*********** Set Default Axios Header ************************
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return { success: true };
      } else {
        return { success: false, message: "Invalid credentials" };
      }
    } catch (error) {
      console.error("Login Error:", error);
      return { success: false, message: error.response?.data?.message || "Login failed" };
    } finally {
      setLoading(false);
    }
  };

  //************ Logout Function **********************
  // const logout = () => {
  //   localStorage.removeItem("authToken");
  //   localStorage.removeItem("refreshToken");
  //   setAuthToken(null);
  //   setUser(null);
  //   delete axios.defaults.headers.common["Authorization"];
  // };

  const logout = async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        await authService.LogOutService({ refreshToken });
      }
    } catch (e) {
      console.warn("Logout API failed:", e.message);
    } finally {
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      setAuthToken(null);
      setUser(null);
      delete axios.defaults.headers.common["Authorization"];
    }
  };
     

  //********** Refresh Token Function (Automatically Get New Token When Expired) ****************
  const refreshAuthToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) return logout();

    try {
      const response = await axios.post("/api/Auth/RefreshToken", { refreshToken });

      if (response.data.success) {
        const { token } = response.data.data;
        localStorage.setItem("authToken", token);
        setAuthToken(token);

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      } else {
        logout();
      }
    } catch (error) {
      console.error("Token Refresh Failed:", error);
      logout();
    }
  };

  //*************  Check Token Expiry & Refresh If Needed **************************
  useEffect(() => {
    if (authToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
    }
  }, [authToken]);

  return (
    <AuthContext.Provider value={{ user, login, logout, authToken, refreshAuthToken, loading, loginPassword }}>
      {children}
    </AuthContext.Provider>
  );
};

//***********  Hook for Auth Context ************************************
export const useAuth = () => useContext(AuthContext);
                                           